var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", { ref: "observer", attrs: { tag: "div" } }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "conteudo" },
          [
            _c("validation-provider", {
              attrs: {
                rules:
                  _vm.resposta.anexoList && _vm.resposta.anexoList.length > 0
                    ? ""
                    : "required",
                name: "conteudo"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-text-editor", {
                          ref: "editorTexto",
                          staticClass: "input",
                          class: { erro: errors && errors.length },
                          attrs: { value: _vm.conteudoReposta },
                          model: {
                            value: _vm.conteudoReposta,
                            callback: function($$v) {
                              _vm.conteudoReposta = $$v
                            },
                            expression: "conteudoReposta"
                          }
                        }),
                        errors && errors.length
                          ? _c("span", { staticClass: "erro help" }, [
                              _vm._v(
                                "Para enviar uma resposta, informe uma mensagem ou anexe um arquivo."
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                false,
                1804437058
              )
            }),
            _vm.showAnexos
              ? _c(
                  "div",
                  { staticClass: "anexo" },
                  [
                    _c("h4", [_vm._v("Anexos mensagem")]),
                    _c("validation-provider", {
                      attrs: {
                        rules: _vm.resposta.conteudo ? "" : "required",
                        name: "anexo"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-anexo", {
                                  attrs: {
                                    id: "upload-resposta-solicitacao",
                                    files: _vm.resposta.anexoList,
                                    scope: "anexos",
                                    errors: errors,
                                    maxSize: 1024
                                  },
                                  on: {
                                    removeFile: _vm.removeFile,
                                    uploadFile: _vm.uploadFile,
                                    downloadDocumentoCadastro: _vm.download
                                  },
                                  model: {
                                    value: _vm.resposta.anexoList,
                                    callback: function($$v) {
                                      _vm.$set(_vm.resposta, "anexoList", $$v)
                                    },
                                    expression: "resposta.anexoList"
                                  }
                                }),
                                errors && errors.length
                                  ? _c("span", { staticClass: "erro help" }, [
                                      _vm._v(
                                        "Para enviar uma resposta, informe uma mensagem ou anexe um arquivo."
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        650978470
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "buttons" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "default" },
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ name: "caixa-entrada" })
                      }
                    }
                  },
                  [_vm._v("Cancelar")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.enviarResposta }
                  },
                  [_vm._v("Enviar")]
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a4f14f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a4f14f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/centralMensagens/AppResposta.vue
// module id = null
// module chunks = 